import parse, { attributesToProps, domToReact } from 'html-react-parser';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from "tss-react/mui";
import ButtonVitec from '../../../app/components/ButtonVitec';
import * as actions from '../../../store/actions/index';
import { AppState } from '../../../store/rootReducer';

const useStyles = makeStyles()(() => ({
  omv: { color: '#000', margin: 15, border: '2px solid' },
  formOmv: { fontSize: '1.2em' },
  divbackground: {
    position: 'absolute',
    width: '100vw',
    height: '100vh',
    backgroundColor: '#000',
    display: 'inline-block',
    zIndex: 1800,
    opacity: 0.4,
    pointerEvents: 'auto', // Capture all pointer events on background
    cursor: 'default'
  },
  wsContentOuter: {
    minWidth: '810px',
    maxWidth: `calc(100vw - ${410}px)`,
    borderRadius: '5px',
    backgroundColor: '#fff',
    display: 'inline-block',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1810,
    paddingLeft: '30px',
    boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
    pointerEvents: 'auto', // Ensure content area captures pointer events
    cursor: 'auto' // Allow normal cursor behavior within the component
  },
  modalContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1799,
    pointerEvents: 'none' // Block all pointer events to elements behind the modal
  }
})
);

export default function OpenMWVitec(props: { omvpressedkey: (event: React.KeyboardEvent<HTMLDivElement>) => void; onsubmit: (e: React.FormEvent<HTMLFormElement> | null) => void; }) {
  const { classes } = useStyles();
  const contentOMW: any = useSelector((state) => (state as AppState).trans.contentOMW);
  // const ValidKey: string[] = ['esc', 'enter'];
  const omvFormRef: any = useRef(null);
  const dispatch = useDispatch();
  const setclickedBtn = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    dispatch(actions.setOmvClickedBtn(e.currentTarget.name));
  }

  // Focus on first input field when component shows or content updates
  useEffect(() => {
    if (contentOMW && omvFormRef.current) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        const firstInput = omvFormRef.current?.querySelector('input[type="text"], input:not([type="submit"]):not([type="button"])');
        if (firstInput) {
          firstInput.focus();
        }
      }, 100);
    }
  }, [contentOMW]);


  // Focus on first field when window/tab gains focus
  useEffect(() => {
    const handleWindowFocus = () => {
      if (contentOMW && omvFormRef.current) {
        // Small delay to ensure focus handling is complete
        setTimeout(() => {
          const firstInput = omvFormRef.current?.querySelector('input[type="text"], input:not([type="submit"]):not([type="button"])');
          if (firstInput) {
            firstInput.focus();
          }
        }, 100);
      }
    };

    // Add event listener for window focus
    window.addEventListener('focus', handleWindowFocus);

    // Cleanup event listener
    return () => {
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, [contentOMW]);

  //
  function handlePressedKey(event: React.KeyboardEvent<HTMLFormElement>): void {
    const { key } = event;
    if (key === 'esc' || key === 'enter') {
      props.omvpressedkey(event as any)
    }
  }
  //
  const handlewebsocketResponseUpdate = (_wsResp: string) => {
    if (_wsResp.includes('<form')) {
      let websocketResponse: string = _wsResp.substring(_wsResp.indexOf('<form'), _wsResp.indexOf('</form') + 7);
      websocketResponse = websocketResponse.replace('<pre>', '');
      websocketResponse = websocketResponse.replace('</pre>', '');

      // Hack - remove some height
      // if (websocketResponse.includes('PALLNR'))
      // for (let i = 0; i < 10; i++) websocketResponse = websocketResponse.replace('<br>', '');

      // processes children nodes 
      const secondPass = {
        replace: (domNode: any) => {
          if (!domNode.attribs) { return; }
          if (domNode.name.toString() === 'input') {
            const { /*onfocus, */ value, ...newAttribs } = domNode.attribs;
            value;
            //
            if (domNode.attribs.type === 'submit') {
              domNode.attribs.onMouseDown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => dispatch(actions.setOmvClickedBtn(e.currentTarget.value));
              return <ButtonVitec _type={'submit'} _fontsize={'1em'} _onclick={setclickedBtn} _name={domNode.attribs.name}
                _label={domNode.attribs.value} _width={150} _height={50} _padding={15} {...attributesToProps(domNode.attribs)} />;
            } else
              domNode.attribs = { ...newAttribs };
            domNode.attribs.class = classes.omv;
            return <input autoComplete="off" {...attributesToProps(domNode.attribs)} />;
          }
        },
      };
      // Cycles throught child nodes and modifies their attributes.
      const firstPass = {
        replace: (domNode: any) => {
          if (!domNode.attribs) { return; }
          if (domNode.name.toString() === 'form') {
            domNode.attribs = { ...domNode.attribs };
            domNode.attribs.class = classes.formOmv;
            return <>{domToReact(domNode.children, secondPass)}</>;
          }
        },
      };
      // Converts string to ReadtDomEl
      return <form onSubmit={(e) => props.onsubmit(e)} className={classes.formOmv}
        name={'omvForm'} id={'omvForm'} ref={omvFormRef} autoComplete="off" method={'post'}
        onKeyUp={(e) => handlePressedKey(e)} >
        {(parse(websocketResponse, firstPass) as React.JSX.Element[])}
      </form>;
    }
  }
  //
  return (
    <>
      {/* Modal container that blocks pointer events to background elements */}
      <div className={classes.modalContainer} />
      <div
        className={classes.divbackground}
        onMouseDown={(e) => e.stopPropagation()}
        onMouseUp={(e) => e.stopPropagation()}
        onMouseMove={(e) => e.stopPropagation()}
      />
      <div
        className={classes.wsContentOuter}
        onMouseDown={(e) => { e.stopPropagation(); }}
        onMouseUp={(e) => { e.stopPropagation(); }}
        onMouseMove={(e) => { e.stopPropagation(); }}
      >
        {contentOMW ? handlewebsocketResponseUpdate(contentOMW) : null}
      </div>
    </>
  );
}